import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

import { Tracking } from '@app/services/tracking/tracking.service';
import { PortalTrackingEvents } from '@app/utils/tracking-events';

@Component({
  selector: 'ask-to-sign-in-modal',
  templateUrl: './ask-to-sign-in-modal.component.html',
  styleUrls: ['./ask-to-sign-in-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AskToSignInModalComponent {
  @Output() hideModal = new EventEmitter();
  @Output() continueAsGuest = new EventEmitter();
  @Output() showSignInModal = new EventEmitter();

  emitShowSignInModal() {
    Tracking.track(PortalTrackingEvents.portalSignInFromSelectOptionContinuePressed);

    this.showSignInModal.emit();
  }

  emitContinueAsGuest() {
    Tracking.track(PortalTrackingEvents.portalContinueAsGuestPressed);

    this.continueAsGuest.emit();
  }
}
